import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RegistryModel, Row } from 'shared/lib';

export type RegistrySelectionCounterProps = Omit<ComponentPropsWithoutRef<'div'>, 'children'>;

export const createRegistrySelectionCounter = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistrySelectionCounter = forwardRef<HTMLDivElement, RegistrySelectionCounterProps>(
		({ className, ...props }, ref) => {
			const { t } = useTranslation();

			const [current, total] = useUnit([model.$totalSelection, model.$total]);

			return (
				<div
					ref={ref}
					className={clsx('registry-selection-counter', className)}
					{...props}
				>
					{t('registry.selection-counter', { current, total })}
				</div>
			);
		},
	);

	return RegistrySelectionCounter;
};
